import React from 'react';
import { Table } from 'antd';
import styles from './index.module.scss';

const defaultData = {
  columns: [],
  rows: [],
};

const BaseTable = ({ data = defaultData }: { data?: any }) => {
  const parseMaybeJson = (value: any) => {
    if (typeof value !== 'string') return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  };

  const parsedData = parseMaybeJson(data) ?? defaultData;
  const rawColumns = parseMaybeJson(parsedData?.columns) ?? [];
  const rawRows = parseMaybeJson(parsedData?.rows) ?? [];

  const normalizedColumns = Array.isArray(rawColumns)
    ? rawColumns.map((col: any, index: number) => {
        if (typeof col === 'string') {
          return { title: col, dataIndex: col, key: col || `col_${index}`, width: 120 };
        }
        const dataIndex = col?.name ?? col?.dataIndex ?? `col_${index}`;
        return {
          title: col?.label ?? col?.title ?? dataIndex,
          dataIndex,
          key: col?.key ?? dataIndex,
          width: 120,
        };
      })
    : [];

  const tableData = Array.isArray(rawRows)
    ? rawRows.map((row: any, rowIndex: number) => {
        // rows 为对象数组：[{a:1,b:2}, ...]
        if (row && typeof row === 'object' && !Array.isArray(row)) {
          return { key: rowIndex, ...row };
        }

        // rows 为二维数组：[[1,2], [3,4]]
        if (Array.isArray(row)) {
          const rowData: Record<string, any> = { key: rowIndex };
          normalizedColumns.forEach((col: any, colIndex: number) => {
            rowData[col.dataIndex] = row[colIndex] ?? '-';
          });
          return rowData;
        }

        return { key: rowIndex, value: row };
      })
    : [];

  return (
    <Table
      columns={normalizedColumns}
      scroll={{ x: 'max-content', y: 200 }}
      size="small"
      className={styles.baseTable}
      bordered
      dataSource={tableData}
      pagination={false}
    />
  );
};

export default BaseTable;
